import { ITemplate } from '../../../extViewmodels/sdk/models';
import { selectKeysOf } from '../../../extViewmodels/sdk/Utils';

export const defaultTemplateName = 'Untitled Newsletter';

// Fields the editor persists on save. The API treats omitted fields as "clear", so keywords
// must stay listed here or folder/label tags get wiped.
const EditorPersistedTemplateKeys: (keyof ITemplate)[] = [
	'content',
	'templateType',
	'subject',
	'name',
	'id',
	'scope',
	'keywords',
];

export const buildBaseTemplatePayload = (template: Partial<ITemplate>): PartiallyRequired<ITemplate, 'content'> => {
	const result = selectKeysOf(
		{ content: {}, name: defaultTemplateName, ...template },
		EditorPersistedTemplateKeys
	) as PartiallyRequired<ITemplate, 'content'>;
	if (result.id === 'new') {
		delete result.id;
	}
	return result;
};
